import axios from "axios";
import NetworkUtils from "@/NetworkUtils";
import store from "../../store";
const authorize =  `Bearer ${store.getters.getToken}`;
const config = {
    headers: { Authorization: authorize }
};

export default {
    loadData: async function (packName) {
        let dataResponse = {};
        let data = await axios.get(NetworkUtils.HOST + "/automate-item-create-data/getByPackName?pack="+packName, config);
        if (data.data.length > 0) {
            //console.log('load ',data.data[0]);
            if(data.data[0].simulatorOptions !== undefined){
                dataResponse.simulatorOptions = data.data[0].simulatorOptions;
            }
            dataResponse.list = data.data[0].list;
        } else {
            dataResponse.list = [];
        }
        if(dataResponse.simulatorOptions === undefined || dataResponse.simulatorOptions === null){
            dataResponse.simulatorOptions = {
                isIncludeOptional: false,
                optionalRatioItem: 0.5,
                optionalRatioGoldItem: 0.3,
                isGenBalanceItem: true,
                isCustomRevive: false,
                costOnGoldDropPercent: 20,//20%
                isIncludeDmg: false,
                isExtraDmg: false,
                dmgPercent: 0.25,//%
                costOnDmgPercent: 2.5,//%
                isIncludeHp: false,
                isExtraHp: false,
                hpPercent: 0.04,
                costOnHpPercent: 15,
                costOnOptionalPercent: 30,//30%
                levelStartHeroRevive: 11,
                isIncSpeedItem: false,
                incSpeedPercent: 0.04,
                costOnIncSpeedPercent: 2,
                isIncludeSupportRevive: false,
                isIncManaItem: false,
                incManaPercent: 0.06,
                costOnIncManaPercent: 10,
                isIncludeStunBoss: false,
                bonusStunPercent: 0.3,
                costOnStunPercent: 18,
            };
        } else {
            if(dataResponse.simulatorOptions.levelStartHeroRevive == undefined){
                dataResponse.simulatorOptions.levelStartHeroRevive = 11;
                dataResponse.simulatorOptions.isIncludeSupportRevive = false;
            }
            if(dataResponse.simulatorOptions.isIncSpeedItem == undefined){
                dataResponse.simulatorOptions.isIncSpeedItem = false;
                dataResponse.simulatorOptions.incSpeedPercent = 0.04;
                dataResponse.simulatorOptions.costOnIncSpeedPercent = 2;
            }
            if(dataResponse.simulatorOptions.isIncManaItem == undefined){
                dataResponse.simulatorOptions.isIncManaItem = false;
                dataResponse.simulatorOptions.incManaPercent = 0.06;
                dataResponse.simulatorOptions.costOnIncManaPercent = 10;
            }
            if(dataResponse.simulatorOptions.isIncludeStunBoss == undefined){
                dataResponse.simulatorOptions.isIncludeStunBoss = false;
                dataResponse.simulatorOptions.bonusStunPercent = 0.3;
                dataResponse.simulatorOptions.costOnStunPercent = 18;
            }
            if(dataResponse.simulatorOptions.isExtraDmg == undefined){
                dataResponse.simulatorOptions.isExtraDmg = false;
                dataResponse.simulatorOptions.isExtraHp = false;
            }
        }

        return dataResponse;
    },

    async pushAutomateItemCreateData(automateItemCreatedData, packName) {
        let config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: authorize
            },
        };
        let data = JSON.stringify(automateItemCreatedData);
        console.log('pushAutomateItemCreateData ', config);
        await axios.post(NetworkUtils.HOST+"/automate-item-create-data/insertOrUpdate?pack="+packName, data, config);
    },

}